import React, { useEffect, useState } from "react";
import './../webcss/invoice.css';
import { POST_DMT_TRANSACTION_INVOICE } from './../Utils/appConstants';
import { getUTCToLocalDateTimeFormat } from './../Utils/function';
import { dmtDetailStatus } from './../Utils/Common';
import { postRequest } from './../Utils/AppApi';
import { useHistory } from "react-router-dom";

function Invoice(props) {
    const history = useHistory();
    const [apiName, setApiName] = useState('');
    const [idata, setData] = useState({});
    const [isPrintButton, setPrintButton] = useState(true);
    const [isDetail, setDetail] = useState([]);

    const print = () => {
        setPrintButton(false);
        setTimeout(() => {
            window.print();
            setPrintButton(true);
        }, 100);
    };

    const handleInvoice = (transactionId) => {
        let payload = { transactionId };
        postRequest(`${apiName}`, payload, history)
            .then((response) => {
                if (response.success === true) {
                    setData(response.data || {});
                    setDetail(response.data?.dmttransactiondetails || []);
                }
            })
            .catch(() => {
                setData({});
                setDetail([]);
            });
    };

    useEffect(() => {
        setApiName(POST_DMT_TRANSACTION_INVOICE);
    }, [props.merchantName]);

    useEffect(() => {
        if (apiName) handleInvoice(props.transactionId);
    }, [apiName, props.transactionId]);

    const handleHideModal = () => {
        if (props.onClose) props.onClose();
    };

    return (
        <div className="container-fluid border border-default p-3 position-relative">

            {/* ❌ TOP RIGHT CLOSE ICON */}
             {isPrintButton && (<span
                onClick={handleHideModal}
                title="Close"
                style={{
                    position: "absolute",
                    top: "12px",
                    right: "16px",
                    width: "36px",
                    height: "36px",
                    borderRadius: "50%",
                    background: "#ffecec",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    zIndex: 10
                }}
                onMouseEnter={e => e.currentTarget.style.background = "#ffdddd"}
                onMouseLeave={e => e.currentTarget.style.background = "#ffecec"}
            >
                <i className="fa fa-times text-danger text-120" />
            </span>)}

            <div className="row">
                <div className="col-12 col-lg-12">

                    {/* CUSTOMER & BENEFICIARY INFO */}
                    <div className="row">
                        <div className="col-sm-6">
                            <div>
                                <span className="text-sm text-grey-m2">Customer Name : </span>
                                <span className="text-600 text-blue">
                                    {idata?.dmtcustomerlists?.customerName}
                                </span>
                            </div>

                            <div>
                                <span className="text-sm text-grey-m2">Customer Mobile : </span>
                                <span className="text-600 text-blue">
                                    {idata?.dmtcustomerlists?.customerMobile}
                                </span>
                            </div>

                            <div className="text-grey-m2 mt-2">
                                <div className="text-600 text-blue">Beneficiary</div>
                                <div>Bank : {idata?.baneData?.bankName}</div>
                                <div>IFSC : {idata?.baneData?.ifscCode}</div>
                                <div>AC : {idata?.baneData?.accountNumber}</div>
                                <div>
                                    Name : {idata?.baneData?.isVerified
                                        ? idata?.baneData?.beneBankName
                                        : idata?.baneData?.beneName}
                                </div>
                                <div>Status : {idata?.baneData?.isVerified ? "Verified" : "Unverified"}</div>
                            </div>
                        </div>

                        <div className="col-sm-6 d-flex justify-content-end">
                            <div className="text-grey-m2">
                                <div>Outlet : {idata?.userdetails?.outletName}</div>
                                <div>
                                    Name : {idata?.userdetails?.firstName} {idata?.userdetails?.lastName}
                                </div>
                                <div>Contact : {idata?.userdetails?.mobile}</div>
                                <div>Address : {idata?.userdetails?.communicationAddress}</div>
                                <div>
                                    Message :
                                    {(idata?.txtStatus === 1 || idata?.txtStatus === 3) &&
                                        <strong className="text-success"> {idata?.message}</strong>}
                                    {(idata?.txtStatus === 2 || idata?.txtStatus === 4) &&
                                        <strong className="text-danger"> {idata?.message}</strong>}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* TRANSACTION TABLE */}
                    {!idata?.isInsufficientFund && (
                        <>
                            <div className="row text-600 text-white bgc-default-tp1 py-25">
                                <div className="col-sm-3">Date & Time</div>
                                <div className="col-sm-3">Transaction ID</div>
                                <div className="col-sm-2">Amount</div>
                                <div className="col-sm-2">Bank RRN</div>
                                <div className="col-sm-2">Status</div>
                            </div>

                            {isDetail.length > 0 ? (
                                isDetail.map((el, i) => (
                                    <div key={i} className="row py-25 border-bottom">
                                        <div className="col-sm-3">{getUTCToLocalDateTimeFormat(el.createdAt)}</div>
                                        <div className="col-sm-3">{el.transactionId}</div>
                                        <div className="col-sm-2">{el.amount}</div>
                                        <div className="col-sm-2">{el.bank_ref_num || "-"}</div>
                                        <div className="col-sm-2">{dmtDetailStatus(el.tx_status)}</div>
                                    </div>
                                ))
                            ) : (
                                <div className="text-center py-3">
                                    No transaction details available.
                                </div>
                            )}
                        </>
                    )}

                    <hr />

                    {/* FOOTER */}
                    <div className="clearfix">
                        <span className="text-secondary-d1 text-105">
                            This is a computer generated receipt & doesn't require signature
                        </span>

                        

                        {isPrintButton && (
                            <a
                                href="#/"
                                onClick={handleHideModal}
                                className="btn btn-danger mx-1px text-95 float-right mt-3 mt-lg-0"
                                style={{ borderRadius: "6px" }}
                            >
                                <i className="mr-1 fa fa-times-circle text-white" /> Close
                            </a>
                        )}


                        {isPrintButton && (
                            <a
                                href="#/"
                                onClick={print}
                                className="btn btn-outline-primary mx-1px text-95 float-right mt-3 mt-lg-0"
                                style={{ borderRadius: "6px", marginRight: "10px" }}
                            >
                                <i className="mr-1 fa fa-print text-primary" /> Print
                            </a>
                        )}
                    </div>

                </div>
            </div>
        </div>
    );
}

export default Invoice;